module.exports = __webpack_public_path__ + "img/Nordeste.fa9f4b81.png";